<template>
    <div v-if="sleepInfoId">

        <el-form @submit="submit" class="pb-32">

            <template v-if="selected_profession === 'profession_type.dayshift' || selected_profession === 'profession_type.unemployed'" slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="row mb-32">
                    <div class="col-12 col-lg-6 col-xl-5 mb-32">
                        <p class="fw-b mb-16 w-100">{{ $t('pages.onboarding-sleepprofile.how_do_you_sleep_weekdays') }}</p>
                        <div class="d-flex">
                            <div class="my-auto">
                                <i-to-bed class="mb-16 i-42 mr-48"></i-to-bed>
                            </div>
                            <el-timepicker class="w-100" v-model="data_week_asleep" @change="data.week_asleep =  (data_week_asleep.HH && data_week_asleep.mm) ? `${data_week_asleep.HH}:${data_week_asleep.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :label="$t('form-elements.to_bed_at')" :placeholder="$t('form-elements.to_bed_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.onboarding-sleepprofile.how_do_you_sleep_weekdays')" data-vv-validate-on="none"></el-timepicker>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-5 mb-3">
                        <p class="fw-b mb-16 w-100">{{ $t('pages.onboarding-sleepprofile.how_early_do_you_sleep_weekdays') }}</p>
                        <div class="d-flex">
                            <div class="my-auto">
                                <i-get-out class="mb-16 i-42 mr-48"></i-get-out>
                            </div>
                            <el-timepicker class="w-100" v-model="data_week_awaken" @change="data.week_awaken =  (data_week_awaken.HH && data_week_awaken.mm) ? `${data_week_awaken.HH}:${data_week_awaken.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :label="$t('form-elements.wakeup_at')" :placeholder="$t('form-elements.wakeup_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.onboarding-sleepprofile.how_early_do_you_sleep_weekdays')" data-vv-validate-on="none"></el-timepicker>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8 col-xl-6">
                        <p class="fw-b mb-16 mt-16">{{ $t('general.type') }}</p>
                        <el-select v-model="person_type" @input="data.person_type_id = person_type.id" rule="" :translate="true" labelKey="name" valueKey="id" :options="personTypes" :name="$t('form-elements.sleep_type')" :label="$t('form-elements.sleep_type')" :placeholder="$t('form-elements.sleep_type_placeholder')"></el-select>
                    </div>
                    <div class="col-12 col-lg-8 col-xl-10">
                        <p class="fw-b mb-8 mt-16">{{ $t('pages.onboarding-sleepprofile.do_you_have_sleep_complaints') }}</p>
                        <el-input v-model="data.sleep_complaint_explanation" type="textarea" rule="max:450" :name="$t('form-elements.explain_sleep_complaint')" :label="$t('form-elements.explain_sleep_complaint')" :placeholder="$t('form-elements.explain_sleep_complaint_placeholder')">
                            <template v-if="data.sleep_complaint_explanation" slot="label-cta">
                                <span class="ml-auto"> {{ data.sleep_complaint_explanation.length }} / 450</span>
                            </template>
                        </el-input>
                    </div>
                </div>

            </template>

            <template v-else-if="selected_profession === 'profession_type.unregular'">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="row">
                    <div class="col-12 col-lg-6 col-xl-5 mb-32">
                        <p class="fw-b mb-16 w-100">{{ $t('pages.onboarding-sleepprofile.how_do_you_sleep_weekdays') }}</p>
                        <div class="d-flex">
                            <div class="my-auto">
                                <i-to-bed class="mb-16 i-42 mr-48"></i-to-bed>
                            </div>
                            <el-timepicker class="w-100" v-model="data_week_asleep" @change="data.week_asleep =  (data_week_asleep.HH && data_week_asleep.mm) ? `${data_week_asleep.HH}:${data_week_asleep.mm}` : null" :bottom="true" :minute-interval="30" :hide-clear-button="true" :label="$t('form-elements.to_bed_at')" :placeholder="$t('form-elements.to_bed_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.onboarding-sleepprofile.how_do_you_sleep_weekdays')" data-vv-validate-on="none"></el-timepicker>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-5 mb-3">
                        <p class="fw-b mb-16 w-100">{{ $t('pages.onboarding-sleepprofile.how_early_do_you_sleep_weekdays') }}</p>
                        <div class="d-flex">
                            <div class="my-auto">
                                <i-get-out class="mb-16 i-42 mr-48"></i-get-out>
                            </div>
                            <el-timepicker class="w-100" v-model="data_week_awaken" @change="data.week_awaken =  (data_week_awaken.HH && data_week_awaken.mm) ? `${data_week_awaken.HH}:${data_week_awaken.mm}` : null" :top="true" :minute-interval="30" :hide-clear-button="true" :label="$t('form-elements.wakeup_at')" :placeholder="$t('form-elements.wakeup_at_placeholder')" v-validate="'time_required'" :data-vv-name="$t('pages.onboarding-sleepprofile.how_early_do_you_sleep_weekdays')" data-vv-validate-on="none"></el-timepicker>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8 col-xl-6">
                        <p class="fw-b mb-16 mt-16">{{ $t('general.type') }}</p>
                        <el-select v-model="person_type" @input="data.person_type_id = person_type.id" rule="" :translate="true" labelKey="name" valueKey="id" :options="personTypes" :name="$t('form-elements.sleep_type')" :label="$t('form-elements.sleep_type')" :placeholder="$t('form-elements.sleep_type_placeholder')"></el-select>
                    </div>
                    <div class="col-12 col-xl-10">
                        <p class="fw-b">{{ $t('pages.onboarding-sleepprofile.shift_patterns') }}</p>
                        <p class="mb-32">{{ $t('pages.onboarding-sleepprofile.shift_patterns_example') }}</p>
                        <el-input v-model="data.description" type="textarea" rule="required|max:255" :name="$t('form-elements.shift_pattern')" :label="$t('form-elements.shift_pattern')" :placeholder="$t('form-elements.shift_pattern_placeholder')">
                            <template v-if="data.description" slot="label-cta">
                                <span class="ml-auto"> {{ data.description.length }} / 255</span>
                            </template>
                        </el-input>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <button class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex mr-auto  mb-32" v-bind:class="{ disabled : loading  }">
                    {{ $t('general.save') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>
    </div>
    <div v-else class="mb-16 text-dark text-center">
        {{ $t('pages.patients.user_has_no_sleepschedule_yet') }}
    </div>
</template>

<script>
import { ElInput, ElForm, ElError, ElTimepicker, ElSelect } from '@/components/forms'

export default {
    name: 'admin-patient-sleepprofile',

    components: { ElInput, ElForm, ElError, ElTimepicker, ElSelect },

    props: {
        patientId: {
            required: true
        },
        professionId: {
            required: true
        },
        sleepInfoId: {
            required: false
        }
    },

    data: () => ({
        loading: false,
        success: false,
        server_error: null,

        selected_profession: '', // dayshift, unregular, unemployed
        update: false,


        data_week_asleep: { HH: null, mm: null },
        data_week_awaken: { HH: null, mm: null },
        data_weekend_asleep: { HH: null, mm: null },
        data_weekend_awaken: { HH: null, mm: null },
        person_type: { id: null, label: null },

        data: {
            person_type_id: null,
            week_asleep: null,
            week_awaken: null,
            weekend_asleep: null,
            weekend_awaken: null,
            description: '',
            sleep_complaint_explanation: '',
        }
    }),

    mounted() {
        this.$store.dispatch('general/professionTypes')
        this.$store.dispatch('general/personTypes')

        if (this.professionId)
            this.$store.dispatch('user/readProfession', { user_id: this.patientId, id: this.professionId }).then((profession) => {
                this.selected_profession = this.professionTypes.find((p) => p.id === profession.profession_type_id).name
            })

        if (this.sleepInfoId)
            this.$store.dispatch('user/readSleepInfo', { user_id: this.patientId, id: this.sleepInfoId }).then((sleepProfile) => {
                this.data.id = sleepProfile.id

                this.person_type = this.personTypes.find((p) => p.id === sleepProfile.person_type_id)
                this.data.person_type_id = sleepProfile.person_type_id

                this.data_week_asleep = sleepProfile.week_asleep ? { HH: this.$moment(sleepProfile.week_asleep, 'HH:mm:ss').format('HH'), mm: this.$moment(sleepProfile.week_asleep, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
                this.data_week_awaken = sleepProfile.week_awaken ? { HH: this.$moment(sleepProfile.week_awaken, 'HH:mm:ss').format('HH'), mm: this.$moment(sleepProfile.week_awaken, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
                this.data_weekend_asleep = sleepProfile.weekend_asleep ? { HH: this.$moment(sleepProfile.weekend_asleep, 'HH:mm:ss').format('HH'), mm: this.$moment(sleepProfile.weekend_asleep, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }
                this.data_weekend_awaken = sleepProfile.weekend_awaken ? { HH: this.$moment(sleepProfile.weekend_awaken, 'HH:mm:ss').format('HH'), mm: this.$moment(sleepProfile.weekend_awaken, 'HH:mm:ss').format('mm') } : { HH: null, mm: null }

                this.data.description = sleepProfile.description
                this.data.sleep_complaint_explanation = sleepProfile.sleep_complaint_explanation
                this.update = true
                this.$nextTick().then(() => this.$validator.validateAll())
            })
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    let user_id = this.patientId
                    this.$store.dispatch(`user/${!this.update ? 'createSleepInfo' : 'updateSleepInfo'}`, { user_id, data: this.data }).then(
                        res => {
                            this.loading = false
                            this.success = true
                            this.update = true
                            this.$toasted.global.info({
                                title: this.$t('toasts.success_update_sleepinfo'),
                                description: this.$t('toasts.success_update_sleepinfo_desc'),
                            });
                            this.$emit('updated', res)
                            setTimeout(() => {
                                this.success = false
                            }, 5000);
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    },

    computed: {
        professionTypes() {
            return this.$store.getters['general/professionTypes']
        },
        personTypes() {
            return this.$store.getters['general/personTypes']
        },
        isFormValid() {
            return !Object.keys(this.fields).some(key => this.fields[key].invalid)
        }
    }
}
</script>
